module.exports = __webpack_public_path__ + "media/icons/youtube-2226e179.svg";